import React from 'react';
import { Pressable, View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import AppStyles from '../AppStyles';

/*
Props:
onChangeValue(): callback for onpress
selected: boolean
label: string (optional) - used for accessibility
*/

const Checkbox = (props) => {
  return (
    <Pressable
      onPress={() => {
        props.onChangeValue != undefined && props.onChangeValue(!props.selected);
      }}
      accessibilityRole="checkbox"
      accessibilityState={{ checked: props.selected }}
      accessibilityLabel={props.label || 'Checkbox'}
      style={{
        // WCAG minimum touch target: 44x44px
        minHeight: 44,
        minWidth: 44,
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      {({ hovered, focused }) => (
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: AppStyles.borderRadii.xs,
            borderWidth: 2,
            borderColor: !props.selected ? AppStyles.colorSet.textPrimary : AppStyles.colorSet.brandPrimary,
            backgroundColor: !props.selected ? AppStyles.colorSet.whiteColor : AppStyles.colorSet.brandPrimary,
            height: 22,
            width: 22,
            ...((hovered || focused) && {
              borderColor: AppStyles.colorSet.brandPrimary,
              shadowColor: AppStyles.colorSet.brandPrimary,
              shadowOffset: { width: 0, height: 0 },
              shadowOpacity: 0.5,
              shadowRadius: 3,
            }),
          }}
        >
          <Feather name="check" size={16} color={AppStyles.colorSet.whiteColor} />
        </View>
      )}
    </Pressable>
  );
};

export default Checkbox;
